import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import Input from '../Input/Input'
import InputMask from 'react-input-mask';
import { 
  ContainerButtonsOther, 
  ContainerButtonsOne,
  Background, 
  StyledModal, 
  HeaderModal, ContentModal, FooterModal, ButtonConfirmation, Label, ImgBackground} from './style'
import bg_modal_confirmation from '../../assets/images/bg-modal-confirmation.png'

const ModalAlertInput = ({ inputType, noBackgroundBlack, modalUp, title, onClick, confirmModal, confirmSim, confirmNao, message, setValue, tel}) => {
  
  return(
    
    <Background  noBackgroundBlack={noBackgroundBlack} >
    
      <StyledModal modalUp={modalUp}>
        <HeaderModal message={ title }>
          <ImgBackground src={bg_modal_confirmation} Alt='Fundo Background' />
        </HeaderModal>
        
        <ContentModal>
        <Label>{ ReactHtmlParser (message) }</Label>
        {
          tel ?
          <InputMask 
          style={styles.inputMask}
          mask=" (99) 99999-9999" 
          maskChar={null}  
          onChange={(event)=>{ setValue(event.target.value)  }}
          />  
          :
          <Input
          style={styles.inputMask}
          onChange={(event)=>{ setValue(event.target.value)  }}
          />  
        }
        
        
          
        </ContentModal>
        <FooterModal>
          {
            confirmModal &&
            <ContainerButtonsOther>
              <ButtonConfirmation BackgroundColor='#40bbca' onClick={ confirmSim }>Sim</ButtonConfirmation>
              <ButtonConfirmation BackgroundColor='#40bbca' onClick={ confirmNao }>Não</ButtonConfirmation>
            </ContainerButtonsOther>
          }
          {
            !confirmModal &&
            <ContainerButtonsOne>
              <ButtonConfirmation BackgroundColor='#40bbca' onClick={ onClick }>OK</ButtonConfirmation>
            </ContainerButtonsOne>
          }
          
        </FooterModal>        
      </StyledModal>
    </Background>
  )
}

let styles = {
  inputMask: {
    
    width:'100%',
    height: '25px',
    marginTop: '10px'
   
  }
}

export default ModalAlertInput
